// ============================================
// アコーディオン
// ============================================

function accordionFunc() {
	const summaryAry = document.querySelectorAll('.js-accordion__trigger');
	if (summaryAry) {
		//スクロールの位置を取得
		let scrollPos = '';
		window.addEventListener('scroll', () => {
			scrollPos = window.scrollY;
		})

		//位置を取得
		const wrapAry = document.querySelectorAll('.js-accordion');
		for (let index = 0; index < wrapAry.length; index++) {
			wrapAry[index].setAttribute('name', 'accordion');
			const pos = wrapAry[index].offsetTop;
			wrapAry[index].dataset.pos = scrollPos + pos;
		}

		summaryAry.forEach(element => {
			element.addEventListener("click", (event) => {
				// デフォルトの挙動を無効化
				event.preventDefault();
				toggleAccordion(element);
			});
		});

		const animTiming = {
			duration: 200,
			easing: "ease-out"
		};

		//閉じる
		const closingAnimKeyframes = (content) => [
			{
				height: `${content.clientHeight}px`,
				opacity: 1,
			}, {
				height: 0,
				opacity: 0,
			}
		];

		//開く
		const openingAnimKeyframes = (content) => [
			{
				height: 0,
				opacity: 0,
			}, {
				height: `${content.clientHeight}px`,
				opacity: 1,
			}
		];

		const toggleAccordion = (element) => {
			const details = element.closest('.js-accordion');
			const content = details.querySelector('.js-accordion__contents');

			if (details.dataset.animStatus === "running") {
				return;
			}

			if (details.open) {
				const closingAnim = content.animate(closingAnimKeyframes(content));
				details.dataset.animStatus = "running";
				closingAnim.onfinish = () => {
					details.removeAttribute("open");
					details.dataset.animStatus = "";
				};
			} else {
				details.setAttribute("open", "true");
				details.dataset.animStatus = "running";
				const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
				openingAnim.onfinish = () => {
					details.dataset.animStatus = "";
				};

				const wrapper = element.closest('.js-accordion')
				const wrapperPos = wrapper.dataset.pos;
				setTimeout(() => {
					window.scrollTo({
						top: wrapperPos - 200,
					})
				}, 200);
			}
		};

		//closeボタンがクリックされた場合
		const closeAry = document.querySelectorAll('.js-accordion__close');
		if (closeAry.length > 0) {
			closeAry.forEach(close => {
				close.addEventListener("click", (event) => {
					const wrapper = close.closest('.js-accordion')
					const wrapperPos = wrapper.dataset.pos;

					event.preventDefault();

					window.scrollTo({
						top: wrapperPos - 200,
					})

					setTimeout(() => {
						toggleAccordion(close);
					}, 100);
				});

			});
		}
	}
}

// ============================================
// エクスポート
// ============================================
export { accordionFunc };